export const signUpSelector = {
  submitWithEmail: "signup-email-button",
};
